<template>
  <transition name="fade">
    <div v-if="show" class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div class="bg-white rounded-xl max-w-lg w-full p-6 shadow-2xl relative">
        <!-- Botão de fechar -->
        <button
          @click="$emit('close')"
          class="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <!-- Logo -->
        <div class="flex justify-center my-6">
          <img src="@/assets/logo1.png" alt="Logo OverX" class="h-8 w-auto" />
        </div>

        <!-- Título -->
        <h2 class="text-xl font-bold text-center mb-2 text-gray-900">
          Calculadora de Lucratividade
        </h2>
        <p class="text-center text-sm text-gray-600 mb-4">
          Descubra quanto você pode economizar e lucrar mais com a gestão completa da
          <b>OverX</b>, mesmo usando o iFood.
        </p>

        <!-- Inputs -->
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-semibold mb-1 text-gray-800">Pedidos por Mês</label>
            <input
              v-model.number="pedidos"
              type="number"
              min="0"
              placeholder="Ex: 150"
              class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm"
            />
          </div>
          <div>
            <label class="block text-sm font-semibold mb-1 text-gray-800">Ticket Médio (R$)</label>
            <input
              v-model.number="ticket"
              type="number"
              min="0"
              placeholder="Ex: 25.50"
              class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm"
            />
          </div>
          <div>
            <label class="block text-sm font-semibold mb-1 text-gray-800">Taxa de Comissão do iFood (%)</label>
            <input
              v-model.number="taxa"
              type="number"
              min="0"
              max="100"
              placeholder="Ex: 13"
              class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm"
            />
          </div>
          <div>
            <label class="block text-sm font-semibold mb-1 text-gray-800">Custo Fixo por Pedido (R$)</label>
            <input
              v-model.number="custoFixo"
              type="number"
              min="0"
              placeholder="Ex: 2.50"
              class="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm"
            />
          </div>

          <button
            @click="calcular"
            class="w-full bg-[#FF7A00] text-white font-semibold py-3 rounded-lg text-sm hover:bg-orange-600 transition-colors mt-2"
          >
            Calcular
          </button>
        </div>

        <!-- Resultados -->
        <div
          v-if="calculado"
          class="mt-8 border-t border-gray-200 pt-5 bg-orange-50 rounded-lg px-5 pb-5 text-gray-800 shadow-inner"
        >
          <h3 class="font-bold text-center text-gray-900 text-lg mb-3">
            Resultados da Sua Gestão
          </h3>

          <div class="space-y-2 text-sm">
            <div class="flex justify-between">
              <span>Lucro Bruto Mensal:</span>
              <b class="text-gray-900">{{ this.formatarValor(lucroBruto) }}</b>
            </div>
            <div class="flex justify-between">
              <span>Custo Total de Comissões:</span>
              <b class="text-red-600">{{ this.formatarValor(custoComissoes) }}</b>
            </div>
            <div class="flex justify-between">
              <span>Lucro Líquido Atual:</span>
              <b class="text-green-600">{{ this.formatarValor(lucroLiquido) }} </b>
            </div>
            <div class="flex justify-between">
              <span>Potencial de Economia:</span>
              <b class="text-yellow-600">{{ this.formatarValor(potencialEconomia) }}</b>
            </div>
          </div>

          <p class="mt-4 text-center text-gray-600 text-sm">
            A sua operação pode ser muito mais lucrativa. Conheça a <b>OverX</b>!
          </p>

          <button
            @click="enviarWhatsApp"
            class="w-full bg-green-500 text-white font-semibold py-2 rounded-lg text-sm hover:bg-green-600 transition-colors mt-4"
          >
            Fale com um Especialista OverX
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getWhatsAppLink } from "@/utils/whatsapp"; 

export default {
  props: {
    show: Boolean,
    formData: Object
  },
  data() {
    return {
      pedidos: 0,
      ticket: 0,
      taxa: 0,
      custoFixo: 0,
      calculado: false,
      lucroBruto: 0,
      custoComissoes: 0,
      lucroLiquido: 0,
      potencialEconomia: 0
    };
  },
  methods: {
    formatarValor(valor) {
        return valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL"
        });
    },
    calcular() {
      this.lucroBruto = this.pedidos * this.ticket;
      this.custoComissoes = (this.lucroBruto * this.taxa) / 100;
      this.lucroLiquido = this.lucroBruto - this.custoComissoes - (this.pedidos * this.custoFixo);
      this.potencialEconomia = this.lucroLiquido * 3.5;
      this.calculado = true;
    },
    enviarWhatsApp() 
    {

      const nome = this.formData?.nome || "";
      const email = this.formData?.email || "";
      const whatsapp = this.formData?.whatsapp || "";
      const desafio = this.formData?.desafio || "";

      const mensagem = `
        Olá, meu nome é *${nome}*!
        Gostaria de saber mais sobre a *OverX*\n

        *Meus dados:*\n
        - *E-mail:* ${email}
        - *WhatsApp:* ${whatsapp}
        - *Desafio atual:* ${desafio}

        ----------------------------

        *Resultados da Calculadora de Lucratividade:*\n
        - *Lucro Bruto Mensal:* ${this.formatarValor(this.lucroBruto)}
        - *Custo Total de Comissões:* ${this.formatarValor(this.custoComissoes)}
        - *Lucro Líquido Atual:* ${this.formatarValor(this.lucroLiquido)}
        - *Potencial de Economia com OverX:\n* ${this.formatarValor(this.potencialEconomia)}

        ----------------------------

        Acredito que minha operação pode ser muito mais lucrativa! 
        Gostaria de falar com um especialista da OverX!
        `;

        const link = getWhatsAppLink(mensagem);
        window.open(link, "_blank");

        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
